import { useState } from "react";
import { SendHorizonal } from "lucide-react";

export default function ChatInput({ onSend, disabled = false, placeholder = "Write a message", value, onChange }) {
  // Uncontrolled by default; a parent that passes value/onChange takes over
  // the composer text. WHY: the AI opener chips in ChatWindow need to fill
  // this input from outside, and lifting the state only when asked keeps
  // every other caller untouched.
  const [inner, setInner] = useState("");
  const controlled = value !== undefined;
  const text = controlled ? value : inner;
  const setText = (t) => (controlled ? onChange?.(t) : setInner(t));

  function submit(e) {
    e.preventDefault();
    const trimmed = text.trim();
    if (!trimmed) return;
    onSend(trimmed);
    setText("");
  }

  return (
    <form onSubmit={submit} className="flex items-center gap-2 border-t border-night-line bg-night-surface p-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))]">
      <input
        value={text}
        onChange={(e) => setText(e.target.value)}
        disabled={disabled}
        placeholder={placeholder}
        className="flex-1 rounded-full border border-night-line bg-night px-4 py-2.5 text-sm text-night-text outline-none transition placeholder:text-night-sub focus:border-brand-primary"
      />
      <button
        type="submit"
        aria-label="Send message"
        disabled={disabled || !text.trim()}
        className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand-primary text-white transition hover:bg-brand-primary-hover active:scale-95 disabled:opacity-40"
      >
        <SendHorizonal size={17} />
      </button>
    </form>
  );
}
